module.exports = __webpack_public_path__ + "assets/f4e4750e451020bdfe48dc77c91d7a75.jpg";